import type { FaireAdPerformancePeriodEntity } from "../../entity_types/adPerformancePeriod";

export const perfP9BudgetCappedOvw202602: FaireAdPerformancePeriodEntity = {
  token: "perf_p9_budget_capped_ovw_202602",
  type: "adPerformancePeriod",
  scope: "OVERVIEW",
  periodType: "RECEIPT",
  startDate: "2026-02-01",
  endDate: "2026-02-28",
  impressions: 57444,
  clicks: 1162,
  adsSpendDollars: 2962,
  budgetDollars: 4900,
  salesDollars: 24010,
  bestEstimateRoas: 8.11,
  bestEstimateType: "ACTUALIZED",
  budgetUtilization: 0.6,
  newCustomersAcquired: 49,
  reorderConversions: 28,
  dataAvailableAtDate: "2026-03-04",
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
